// Cookie utility functions
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(";").shift() : null;
};

export const clearCookie = (name, domain = null) => {
  const cookieString = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  document.cookie = cookieString;
  if (domain) {
    document.cookie = `${name}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
};

export const clearAuthCookies = () => {
  const domain = window.location.hostname;
  const mainDomain = domain.split(".").slice(-2).join(".");
  const authCookies = ["whoosh_uuid", "whoosh_token"];
  authCookies.forEach(cookie => {
    clearCookie(cookie);
    clearCookie(cookie, mainDomain);
  });
};

export const hasAuthCookies = () => {
  return getCookie("whoosh_uuid") && getCookie("whoosh_token");
};
